import React from "react";
import styled from "@emotion/styled";
import { useLocation, useNavigate } from "react-router-dom";

function Header({ title, back }) {
  const navigate = useNavigate();
  const location = useLocation();
  const showBack = back ?? location.pathname !== "/";

  const handleLogout = () => {
    if (!window.confirm("로그아웃하시겠습니까?")) return;
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login", { replace: true });
  };

  return (
    <Bar>
      <Left>
        {showBack ? (
          <BackBtn aria-label="뒤로" onClick={() => navigate(-1)}>
            ‹
          </BackBtn>
        ) : (
          <Spacer />
        )}
      </Left>
      <Title>{title || "더트루 변경 요청"}</Title>
      <Right>
        <LogoutBtn onClick={handleLogout}>로그아웃</LogoutBtn>
      </Right>
    </Bar>
  );
}

const Bar = styled.header`
  position: sticky;
  top: 0;
  height: 52px;
  background: #ffffff;
  border-bottom: 1px solid #e6e8eb;
  display: grid;
  grid-template-columns: 56px 1fr 76px;
  align-items: center;
  z-index: 10;
`;
const Left = styled.div``;
const Right = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const Title = styled.div`
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #222;
`;
const BackBtn = styled.button`
  width: 56px;
  height: 52px;
  border: 0;
  background: transparent;
  font-size: 28px;
  color: #003580;
`;
const Spacer = styled.div`
  width: 56px;
  height: 52px;
`;
const LogoutBtn = styled.button`
  height: 52px;
  padding: 0 14px;
  border: 0;
  background: transparent;
  font-size: 13px;
  color: #888;
`;

export default Header;
